// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Grid from 'brastrap/helpers/l-grid/l-grid';
import Link from 'brastrap/containers/link/LinkContainer';

export type Props = {
  address: {
    address1: string,
    address2: string,
    address3: string,
    postCode: string,
    town: string,
  },
  availableQuantity: number,
  telephone: string,
};

const ShopFinderResult = ({ address, availableQuantity, telephone }: Props) => {
  const aProps = {
    href: `tel:${telephone}`,
  };

  return (
    <Grid>
      <Grid.Unit>
        <p className="c-stock-finder-result__address">
          <b>
            <FormattedMessage
              id="stock-finder.result.address"
              defaultMessage="Address:"
            />
          </b>
          &nbsp;
          {Object.keys(address)
            .filter(prop => !!address[prop])
            .map((prop, index) => (
              // $FlowFixMe - Need to upgrade Flow to add Fragment support.
              <React.Fragment key={prop}>
                {address[prop]}
                {index < Object.keys(address).length && <br />}
              </React.Fragment>
            ))}
        </p>
      </Grid.Unit>
      <Grid.Unit>
        <div className="c-stock-finder-result__stock-status">
          <FormattedMessage
            id="stock-finder.result.stock"
            defaultMessage="{availableQuantity, plural,
    =0 {No}
    other {In}
} Stock"
            values={{ availableQuantity }}
          />
          {!!availableQuantity && (
            <Link {...aProps} className="c-stock-finder-result__link">
              <FormattedMessage
                id="stock-finder.result.call"
                defaultMessage="Call {telephone} to confirm availability"
                values={{ telephone }}
              />
            </Link>
          )}
        </div>
      </Grid.Unit>
    </Grid>
  );
};

export default ShopFinderResult;
